'use client'

import { TagIcon } from '@heroicons/react/24/solid'

export const DiscountList = ({ discountNames = [] }: { discountNames?: string[] }) => {
  if (!discountNames.length) return null

  return (
    <div className="flex flex-col">
      {discountNames.map((discountName, index) => (
        <div
          className="flex items-center gap-1 text-body-xs font-medium text-bodi-gray-medium"
          key={index}
        >
          <TagIcon className="size-3 -scale-x-100 text-bodi-gray-butters" />
          <div> {discountName}</div>
        </div>
      ))}
    </div>
  )
}
